import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import Slider from 'react-slick';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

class Heroes extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {};
	}

	componentWillMount() {
		document.title = 'Diamonds Direct Heroes in Uniform - Engagement Rings, Jewelry, and More';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	}

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  userNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

	render() {
		return <div className='Heroes'>
			<div className='blocksWrapper'>
				<div className='imageBlock'></div>
				<div className='contentBlock'>
					<div className='heroesTitle'>Heroes in Uniform</div>
					<div className='heroesText' style={{marginBottom: '20px'}}>We invite you to take advantage of one of these exclusive offers:</div>
					<div className='heroesSubtitle'>15% Off*</div>
					<div className='heroesOr'>or</div>
					<div className='heroesSubtitle'>Special Financing for 3 Years with Approved Credit</div>
					<div className='heroesText'>Active duty military and veterans, police, fire, paramedics and nurses are eligible to receive this promotion. To redeem this special offer:</div>
					<div className='heroesText'><span className='textEm'>In Store:</span> Present a valid, non-classified form of identification to your Diamond&nbsp;Expert.</div>
					<div className='heroesText'><span className='textEm'>Online:</span> Email <a href='mailto:online@diamondsdirect.com'>online@diamondsdirect.com</a> and we will respond with check-out instructions.</div>
					<div className='heroesHandwriting'>We thank our hometown heroes for<br />your service and courage!</div>
					<div className='hereosLegal'>*This offer can’t be combined with other offers or special financing. 15% off does not apply to certified diamonds or price protected designer lines. Deposit may be required on special orders.</div>
				</div>
			</div>
		</div>;
	}
}
export default Heroes;

function mapStateToProps(state) {
  return {
    header: state.header,
  };
}

export const HeroesContainer = connect(
  mapStateToProps,
  allActionCreators
)(Heroes);


// WEBPACK FOOTER //
// ./src/components/views/heroes/Heroes.jsx